export default __webpack_public_path__ + "static/media/voron.49a5285c.png";